import { SettingsVerticalIcon } from 'components/icons/SettingsVertical'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { activeTools } from './hooks'

export const QATools = observer(function QATools() {
  const open = activeTools.enabled.get()
  const tools = activeTools.tools

  useEffect(() => {
    // listen to shift-Q to toggle the QA tools
    const listener = (e: KeyboardEvent) => {
      // detect that we're not in an input field
      if (e.target instanceof HTMLInputElement) return
      if (e.target instanceof HTMLTextAreaElement) return

      if (e.key === 'Q' && e.shiftKey) {
        activeTools.toggle()
      }
    }

    document.addEventListener('keydown', listener)

    return () => {
      document.removeEventListener('keydown', listener)
    }
  }, [tools])

  if (tools.size === 0) return null

  const toolsArray = Array.from(tools)

  return (
    <div className="fixed left-0 top-0 z-[9999] min-w-[300px]">
      <div className="flex max-h-full flex-col rounded-br-xl bg-white  shadow-lg">
        {!open && (
          <div
            className="flex cursor-pointer flex-row items-center gap-1 p-2 text-label-medium text-on-surface-var"
            onClick={() => activeTools.toggle()}
          >
            <SettingsVerticalIcon size={14} />
            Settings
          </div>
        )}
        {open && (
          <div className="flex max-h-screen flex-col flex-wrap text-body-medium">
            <div
              className="flex cursor-pointer flex-row items-center gap-1 p-2 text-label-medium text-on-surface-var"
              onClick={() => activeTools.toggle()}
            >
              <SettingsVerticalIcon size={14} />
              Settings
            </div>
            {toolsArray.map(([name, { label, callback }]) => {
              if (typeof label === 'string') {
                return (
                  <a
                    className="cursor-pointer p-2 hover:bg-gray-300"
                    key={name}
                    onClick={async () => {
                      const keepOpen = await callback()
                      if (keepOpen) return
                      activeTools.hide()
                    }}
                  >
                    {label}
                  </a>
                )
              }

              return <div key={name}>{label}</div>
            })}
          </div>
        )}
      </div>
    </div>
  )
})
